<template>
    <div class="index">
        <banner-login v-if="$siteConfig.bannerShowLogin"></banner-login>
        <banner v-else></banner>

        <div class="content sec2" :style="{marginTop: $siteConfig.bannerShowLogin ? '30px':'60px'}">
            <el-row :gutter="12">
                <el-col :span="18">
                    <news></news>
                </el-col>
                <el-col :span="6">
                    <about v-if="$siteConfig.bannerShowLogin"></about>
                    <enters v-else></enters>
                </el-col>
            </el-row>
        </div>

        <ad v-if="$siteConfig.showAd"></ad>

        <business></business>

        <!-- 二维码固定 -->
        <div class="ewmcode" v-if="$siteName == 'nm'">
            <!-- <img src="/images/kfcode.jpg" alt="" style="width:150px">
            <p style="margin-bottom:10px">客服二维码</p> -->
            <img src="/nm/images/ewmcode.jpg" alt="" style="width:150px">
            <p>公众号二维码</p>
        </div>
    </div>
</template>

<script>
import Banner from './index/sections/banner';
import BannerLogin from './index/sections/banner-login';
import News from './index/sections/news';
import Enters from './index/sections/enters';
import Business from './index/sections/business';
import About from './index/sections/about';
import ad from './index/sections/ad.vue';

export default {
    components: {
        Banner,
        News,
        Enters,
        Business,
        BannerLogin,
        About,
        ad

    },
    data() {
        return {
            
        }
    },
    methods: {
        
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    .ewmcode{
        width: 150px;
        position: fixed;
        bottom: 0;
        left: 0;
        text-align: center;
        background: #F5F7FD;
    }
</style>
